import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import { CONSTANT_VARIABLES } from '../../views/common/Constant_Variables/constants';
import notification from '@tt/components/Notification';

// quality accurance contact
function* fetchQualityAssuranceContact({ qualityAssuranceContactParams }) {
  try {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: true }));
    const { data } = yield call(api.get, {
      route: 'contact/getsearched',
      params: qualityAssuranceContactParams,
    });
    const qualityAssuranceContactData = data;
    yield put(Actions.setQualityAssuranceContact({ qualityAssuranceContactData }));
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// quality accurance contact
function* fetchQualityAssuranceContactCheckEmail({ qualityAssuranceContactParams }) {
  try {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: true }));
    const { data } = yield call(api.get, {
      route: 'contact/CheckEmailExist',
      params: qualityAssuranceContactParams,
    });
    const qualityAssuranceContactCheckEmailData = data;
    yield put(Actions.setQualityAssuranceContactCheckEmail({ qualityAssuranceContactCheckEmailData }));
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceContactAll() {
  try {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: true }));
    const { data } = yield call(api.get, {
      route: 'contact',
    });
    const qualityAssuranceContactAllData = data;
    yield put(Actions.setQualityAssuranceContactAll({ qualityAssuranceContactAllData }));
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceContactById({ contactId }) {
  try {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: true }));
    const { data } = yield call(api.get, {
      route: 'contact/' + contactId,
    });
    const qualityAssuranceContactData = data;
    yield put(Actions.setQualityAssuranceContact({ qualityAssuranceContactData }));
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateQualityAssuranceContact({
  actionName,
  qualityAssuranceContactObj,
  qualityAssuranceContactParams,
  caller,
}) {
  try {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'contact',
      data: qualityAssuranceContactObj,
    });
    yield put(Actions.fetchQualityAssuranceContact({ qualityAssuranceContactParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.Q_A_MANAGEMENT_CONTACT_SUCCESS_ADD
        : CONSTANT_VARIABLES.Q_A_MANAGEMENT_CONTACT_SUCCESS_UPDATE,
      ''
    );
    if (caller) {
      console.log('caller', caller);
      caller();
    }
  } catch (error) {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteQualityAssuranceContact({ contactId, qualityAssuranceContactParams }) {
  try {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: true }));
    yield call(api.delete, {
      route: 'contact/' + contactId,
    });
    yield put(Actions.fetchQualityAssuranceContact({ qualityAssuranceContactParams }));
    notification('success', CONSTANT_VARIABLES.Q_A_MANAGEMENT_CONTACT_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setQualityAssuranceContactLoader({ qualityAssuranceContactLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

// quality accurance complaint source
function* fetchQualityAssuranceCS({ qualityAssuranceCSParams }) {
  try {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/GetSearchedComplaintSource',
      params: qualityAssuranceCSParams,
    });
    const qualityAssuranceCSData = data;
    yield put(Actions.setQualityAssuranceCS({ qualityAssuranceCSData }));
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchQualityAssuranceCSById({ complaintSourceId }) {
  try {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: true }));
    const { data } = yield call(api.get, {
      route: 'complaint/complaintSource/' + complaintSourceId,
    });
    const qualityAssuranceCSData = data;
    yield put(Actions.setQualityAssuranceCS({ qualityAssuranceCSData }));
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: false }));
  } catch (error) {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdateQualityAssuranceCS({ actionName, qualityAssuranceCSObj, qualityAssuranceCSParams }) {
  try {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'complaint/complaintSource',
      data: qualityAssuranceCSObj,
    });
    yield put(Actions.fetchQualityAssuranceCS({ qualityAssuranceCSParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.Q_A_MANAGEMENT_C_S_SUCCESS_ADD
        : CONSTANT_VARIABLES.Q_A_MANAGEMENT_C_S_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deleteQualityAssuranceCS({ complaintSourceId, qualityAssuranceCSParams }) {
  try {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: true }));
    yield call(api.delete, {
      route: 'complaint/deleteComplaintSource/' + complaintSourceId,
    });
    yield put(Actions.fetchQualityAssuranceCS({ qualityAssuranceCSParams }));
    notification('success', CONSTANT_VARIABLES.Q_A_MANAGEMENT_C_S_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setQualityAssuranceCSLoader({ qualityAssuranceCSLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT, fetchQualityAssuranceContact),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT_CHECK_EMAIL, fetchQualityAssuranceContactCheckEmail),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT_ALL, fetchQualityAssuranceContactAll),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_CONTACT_BY_ID, fetchQualityAssuranceContactById),
    takeLatest(ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_CONTACT, addUpdateQualityAssuranceContact),
    takeLatest(ActionTypes.DELETE_QUALITY_ASSURANCE_CONTACT, deleteQualityAssuranceContact),

    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_C_S, fetchQualityAssuranceCS),
    takeLatest(ActionTypes.FETCH_QUALITY_ASSURANCE_C_S_BY_ID, fetchQualityAssuranceCSById),
    takeLatest(ActionTypes.ADD_UPDATE_QUALITY_ASSURANCE_C_S, addUpdateQualityAssuranceCS),
    takeLatest(ActionTypes.DELETE_QUALITY_ASSURANCE_C_S, deleteQualityAssuranceCS),
  ]);
}
